// extracted by mini-css-extract-plugin
export var container = "sitemap-module--container--757f6";
export var sitemapColumn = "sitemap-module--sitemapColumn--fadc1";
export var sitemapList = "sitemap-module--sitemapList--047d3";
export var sitemapModule = "sitemap-module--sitemapModule--387b0";
export var sitemapSection = "sitemap-module--sitemapSection--52284";
export var subHeading = "sitemap-module--subHeading--1e147";